import {useQuery} from '@apollo/client';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import LinearProgress from '@material-ui/core/LinearProgress';
import {
  CreateTournamentForm,
  DialogProps,
} from 'packages/common-types/base-types';
import {
  GetTournamentData,
  GetTournamentVars,
} from 'packages/common-types/queries-types';
import {GET_TOURNAMENT} from 'packages/graphql/v2/queries';
import useTournament from 'packages/hooks/use-tournament';
import {FormProvider, useForm} from 'react-hook-form';
import Swal from 'sweetalert2';
import EditTournamentForm from './new-tournament/Form';

type Props = DialogProps & {
  tournamentId: string;
  refectTournaments: () => {};
};

const EditTournament = (props: Props) => {
  const {toggle, modalOpen, tournamentId, refectTournaments} = props;
  const {data: tournamentData} = useQuery<GetTournamentData, GetTournamentVars>(
    GET_TOURNAMENT,
    {
      variables: {tournamentId},
    }
  );
  const {editTournament, isLoading: editing} = useTournament();
  const methods = useForm<CreateTournamentForm>();

  const onSubmit = async (formData: CreateTournamentForm) => {
    const {
      country,
      state,
      city,
      gender,
      modalityGame,
      pointLimit,
      numberOfRounds,
      tournamentType,
      tournamentCategory,
      hasFinal,
      ...rest
    } = formData;

    try {
      const updateTournament = {
        address: {
          country,
          state,
          city,
        },
        conditions: {
          gender,
          modalityGame,
          tournamentType,
          pointLimit: +pointLimit,
          numberOfRounds,
          tournamentCategory,
        },
        hasFinal: !!hasFinal,
        ...rest,
      };
      const res = await editTournament({tournamentId, input: updateTournament});
      if (res?.data) {
        Swal.fire({
          title: 'Hecho!',
          text: 'Torneo actualizado correctamente',
          icon: 'success',
        });
        refectTournaments();
        toggle();
      }
    } catch (error) {
      console.error(error);
      Swal.fire({
        title: 'Error!',
        text: 'Ha ocurrido un error al actualizar el torneo',
        icon: 'error',
      });
    }
  };

  return (
    <FormProvider {...methods}>
      <Dialog
        fullWidth
        maxWidth="sm"
        open={modalOpen}
        onClose={toggle}
        aria-labelledby="dialog-create-tournament"
      >
        <DialogTitle id="title-create-tournament">Editar torneo</DialogTitle>
        {editing && <LinearProgress />}

        <DialogContent dividers>
          <EditTournamentForm
            tournamentData={tournamentData?.getTournament}
            onSubmit={onSubmit}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={toggle} color="default">
            Cancelar
          </Button>
          <Button type="submit" form="create-tournament-form" color="primary">
            Guardar cambios
          </Button>
        </DialogActions>
      </Dialog>
    </FormProvider>
  );
};

EditTournament.displayName = 'EditTournament';

export default EditTournament;
